import { render, staticRenderFns } from "./CameraPageShootCardAutoDriversLicenseBack.vue?vue&type=template&id=39dfc8d5&"
import script from "./CameraPageShootCardAutoDriversLicenseBack.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardAutoDriversLicenseBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports